import { post, put, del } from '../request'

export const createTransportation = (data) => post('api/transportations', { data })
export const updateTransportation = (id, data) => put(`api/transportations/${id}`, data)
export const deleteTransportation = (id) => del(`api/transportations/${id}`)
